// extracted by mini-css-extract-plugin
export default {"instructions":"VlL3I9rRm7Z8N3njDkdI","signatureOption":"HHrzZd9QY2_VE7xtLGo_"};